// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 兼容ie-begin
import 'babel-polyfill'
// 兼容ie-end
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import VueLazyload from 'vue-lazyload'
import axios from 'axios'
import jsonp from 'jsonp'
import jquery from 'jquery'
import lib from './assets/lib/lib'
import qs from 'qs'
// import particles from 'particles.js'

Vue.use(VueLazyload)

axios.defaults.baseURL = 'https://cgi.bbgame.com.tw/v1/area-kr/sgz'
Vue.prototype.$http = axios
Vue.prototype.$jsonp = jsonp
Vue.prototype.$ = jquery
Vue.prototype.$lib = lib
Vue.prototype.$qs = qs
Vue.prototype.$NODE_BASEURL = process.env.NODE_NEWBASEURL
Vue.prototype.$NODE_PROJECTID = process.env.NODE_PROJECTID
// Vue.prototype.$particles = particles

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // console.log('来自全局导航钩子main.js:', to)
  // console.log('来自全局导航钩子main.js:',from);
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '新三國志手機版'
  }
  next()
})
router.afterEach(route => {
  // ...
  // $("html,body").animate({"scrollTop":0},0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js